import React from "react";
import { Formik, Form, Field, FormikHelpers, useFormik } from "formik";
import * as Yup from "yup";
import { Input, InputWrapper } from "../composites";
import { Grid } from "@chakra-ui/layout";
import { Select } from "@chakra-ui/select";
import _ from "lodash";
import { Button } from "@chakra-ui/button";
import {
  changePassword,
  createTransaction,
  createUser,
} from "../../services/crm.service";
import { useShowToastHook } from "../../hooks/show-toast-hook";
import ErrorBoundary from "../ErrorBoundary";

const TYPE = {
  DEPOSIT: "Deposit",
  WITHDRAW: "Withdraw",
  CREDIT_IN: "Credit In",
  CREDIT_OUT: "Credit Out",
};

//group f_name m_name l_name  master_password investor_password  email phone company country zipcode state city address
const userSchema = Yup.object().shape({
  login: Yup.number().required("Login ID is required"),
  type: Yup.number().required("Select type of password change"),
  password: Yup.string()
    .required("Password is required")
    .matches(
      /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
      "Password must contain at least 8 characters, one uppercase, one number and one special case character"
    ),
});

const ChangePasswordForm = ({}) => {
  const { showError, showSuccess } = useShowToastHook();

  const formik = useFormik({
    initialValues: {
      login: undefined,
      type: 0,
      password: "",
    },
    validationSchema: userSchema,
    onSubmit: async (values, actions) => {
      actions.setSubmitting(true);

      try {
        const result = await changePassword(values);

        if (result?.data?.status) {
          showSuccess("Password changed Successfully.");
          actions.resetForm();
        } else {
          showError(
            result?.data?.message ??
              "Something went wrong, please try again later."
          );
        }
      } catch (error) {
        showError("Something went wrong, please try again later.");
      }

      actions.setSubmitting(false);
    },
  });

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Grid
          my={6}
          gap={6}
          width="100%"
          maxWidth={["100%", "100%", "900px", "900px"]}
        >
          <Input
            title="Login"
            type="number"
            name="login"
            value={formik?.values?.login}
            onChange={formik?.handleChange}
            onBlur={formik?.handleBlur}
            errorMessage={
              formik?.touched?.login && formik?.errors?.login
                ? formik?.errors?.login
                : ""
            }
          />

          <InputWrapper
            title="Type"
            errorMessage={
              formik?.touched?.type && formik?.errors?.type
                ? formik?.errors?.type
                : ""
            }
          >
            <Select
              name="type"
              value={formik?.values?.type}
              onChange={formik?.handleChange}
              onBlur={formik?.handleBlur}
            >
              <option value={0}> Master Password </option>
              <option value={1}> Investor Password </option>
            </Select>
          </InputWrapper>

          <Input
            title="Password"
            type="text"
            name="password"
            value={formik?.values?.password}
            onChange={formik?.handleChange}
            onBlur={formik?.handleBlur}
            errorMessage={
              formik?.touched?.password && formik?.errors?.password
                ? formik?.errors?.password
                : ""
            }
          />

          <Button
            colorScheme="blue"
            type="submit"
            isLoading={formik?.isSubmitting}
          >
            Change Password
          </Button>
        </Grid>
      </form>
    </>
  );
};

export default ChangePasswordForm;
